import { isGuestOpenPath } from "./guest-access";

/**
 * Member-gated Learning Hub pages render the same short "join to continue"
 * card to every signed-out visitor — including Googlebot, which never has a
 * session. Submitting ~130 URLs that all serve identical stub content is what
 * produced the "Crawled – currently not indexed" / "Soft 404" / "Alternative
 * page with proper canonical" clusters in Search Console.
 *
 * These pages therefore carry `noindex, follow`: they stay crawlable (so link
 * equity flows on to the public catalogue) but are not offered for indexing.
 * The moment a path becomes guest-open in `guest-access.ts`, the tag and the
 * sitemap entry both come back automatically — the two share one source.
 */
export function gatedRobotsMeta(path: string): { name: string; content: string }[] {
  return isGuestOpenPath(path) ? [] : [{ name: "robots", content: "noindex, follow" }];
}

/** True when a Learn path may be submitted to search engines. */
export function isIndexableLearnPath(path: string): boolean {
  return isGuestOpenPath(path);
}
